const setCookie = (name, value, path) => {
	let cookie_string = name + "=" + escape(value);

	const expires = new Date(Date.now() + 86400e3);
	cookie_string += "; expires=" + expires.toGMTString();

	if (path)
		cookie_string += "; path=" + escape(path);

	document.cookie = cookie_string;
};

const getCookie = (cookie_name) => {
	const results = document.cookie.match('(^|;) ?' + cookie_name + '=([^;]*)(;|$)');

	if (results) {
		return (unescape(results[2]));
	} else {
		return null;
	}
};

export {setCookie, getCookie};